import AbstractListResource from "./abstract/abstract-list-resource"
import defines from "dpsdk/defines"
const {Resource} = defines
import Ticket from './items/ticket'

class Tickets extends AbstractListResource {
    constructor() {
        super(Resource.TICKETS, Ticket)
        super.setCallbacks({
            get: (params) => this.api().resourceGet(Resource.TICKETS, params),
            update: (id, params) => this.api().resourceUpdate(Resource.TICKETS, id, params),
            create: (params) => this.api().resourceCreate(Resource.TICKETS, params),
            delete: (id) => this.api().resourceDelete(Resource.TICKETS, id)
        })
    }


}

export default new Tickets()
